import { defineStore } from 'pinia';
import { requestFitplus } from '../api';
import type { LogUserInteractionsRequest } from '@common/openapi-client';

const useLogStore = defineStore('log', () => {
    const endPoint = {
        POST_USER_INTERACTION_LOG: 'log-data/user-interaction',
    };

    const postUserInteractionLog = async (payload: LogUserInteractionsRequest) => {
        await requestFitplus<void>(endPoint.POST_USER_INTERACTION_LOG, 'post', payload);
    };

    return {
        postUserInteractionLog,
    };
});

export default useLogStore;
